import { BaseModel } from "./base.model";

export class AccessInviteModel extends BaseModel  {
    name?: String; 
    email?: String; 
    businessUnitId?: String;
    loginType?: Number; 
    isProcessed?: Boolean; 
    roles?: string[] = [];
}

